import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

import { removeEditableFlags } from '@common/helpers/helpers';
import useMemoLanguageOptions from '@hooks/useMemoLanugageOptions';
import EditorLanguageSelector from '@common/components/EditorLanguageSelector/EditorLanguageSelector';

const PreviewDialog = ({
  fullScreen = true,
  onCancel = null,
  isUrl = false,
  src,
  title,
  isOpen,
}) => {
  const { t } = useTranslation();

  const notEditableSrc = removeEditableFlags(src || '');

  return (
    <Dialog fullWidth fullScreen={fullScreen} maxWidth={'md'} open={isOpen}>
      <DialogTitle
        sx={{
          boxShadow: 3,
          marginBottom: '1rem',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <Typography data-test-id='pdf-preview-title'>{title}</Typography>
      </DialogTitle>

      <DialogContent
        sx={{
          pt: '1rem!important',
          overflow: 'hidden',
          height: 'calc(100vh - 1rem)',
        }}
      >
        <Box sx={{ height: '100%' }}>
          <iframe
            style={{
              height: '100%',
              width: '100%',
              border: 'none',
              overflow: 'auto',
            }}
            title='pdf-preview'
            {...(isUrl ? { src: notEditableSrc } : { srcDoc: notEditableSrc })}
          />
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          backgroundColor: 'primary.background',
          justifyContent: 'space-between',
        }}
      >
        <Button
          disableFocusRipple
          variant='outlined'
          startIcon={<CancelIcon />}
          data-test-id='pdf-preview-cancel'
          onClick={onCancel}
          color='error'
        >
          {t('cancel_button')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewDialog;
